/**
 * Cand se arata avertizarea „aceste clase sunt deja punctate" (SP-05a).
 *
 * 🔴 DE CE E O FUNCTIE SEPARATA, si nu un `&&` in JSX.
 *
 * Prima versiune randa avertizarea in `EcranClase`. Corect ca intentie, si
 * IMPOSIBIL ca rezultat: lista intra in state la trimitere, iar in acelasi
 * handler se face `COMPLETE_LESSON`, care schimba `status` in `'completed'`;
 * `LessonPlayer` are un return timpuriu pe `isCompleted` si randeaza
 * `CompletionScreen` INAINTE de ramura cu `EcranClase`. Ordinea ramurilor e
 * faptul portant, si se citeste din sursa.
 *
 * ⚠️ Aici scria „cele doua `setState` fiind in acelasi handler, React le
 * grupeaza". NU s-a masurat de nimeni — ipoteza a circulat in patru locuri
 * inainte sa fie pusa la indoiala. Si nici nu e portanta: cu grupare, ecranul cu
 * avertizarea nu se monteaza niciodata cu lista nevida; fara grupare, s-ar monta
 * pentru un singur cadru, pe care omul tot nu-l poate citi. Concluzia nu se
 * schimba, motivul da. Vezi `docs/knowledge/prop-pasat-dar-nevazut.md`.
 *
 * Prop pasat corect, ramura corecta, alta ramura castiga. Din afara arata
 * identic cu „campul nu vine de la server" — si asta l-a facut invizibil si in
 * review pe diff, si in masuratoarea pe DEV: V1 a vazut absenta casetei si a
 * refuzat, corect, s-o declare defect fara corpul raspunsului. Corpul nu conta.
 *
 * 🔴 A DOUA CONDITIE, ceruta de S1: avertizarea e despre ce TOCMAI ai trimis.
 * `CompletionScreen` se randeaza si la reintrarea pe o lectie deja completata,
 * saptamana viitoare. Un mesaj despre clase deja punctate, aparut atunci, ar
 * vorbi despre o trimitere pe care omul n-a facut-o acum si n-o mai poate
 * schimba. Azi lista e goala la o montare noua oricum — dar asta e un accident
 * al implementarii, nu o regula scrisa: in ziua in care cineva o citeste din
 * `lessonAnswer` (date de la server, prezente si la reintrare), avertizarea ar
 * reaparea singura. Regula sta aici, si are test.
 */
export function avertizareClaseDejaPunctate(
    clase: unknown,
    trimisInSesiuneaCurenta: boolean
): string[] {
    if (!trimisInSesiuneaCurenta) return [];
    if (!Array.isArray(clase)) return [];
    const curatate = clase.filter((c): c is string => typeof c === 'string' && c.trim() !== '');
    return curatate;
}

/**
 * Textul avertizarii, sau `null` cand n-avem ce spune.
 *
 * ⚠️ Spune ce **E**, nu ce **VA FI**: adevarul se stabileste la aprobare, iar
 * intre trimitere si aprobare altcineva poate aproba sau respinge. «Va fi
 * respinsă» ne-ar face mincinosi in clipa in care starea se muta. Formularea e
 * a lui B1.
 */
export function textAvertizareClase(clase: string[]): string | null {
    if (clase.length === 0) return null;
    if (clase.length === 1) {
        return `„${clase[0]}” este deja punctată la școala ta pentru activitatea aceasta.`;
    }
    return `Aceste clase sunt deja punctate la școala ta pentru activitatea aceasta: ${clase.join(', ')}.`;
}
